//
import React, { Component } from "react"
import PropTypes from "prop-types"
import Layout from "../Layout"
import { Layout12 } from "../ContentBox"
import { DivHover, DivHelp } from "./styled"

class CarouselAnimationView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false,
    }
  }
  onHover = () => {
    this.setState({ hover: true })
  }
  onMouseOver = () => {
    this.setState({ hover: false })
  }
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="CarouselAnimationView"></Layout>
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    )
  }
}

CarouselAnimationView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  layout: PropTypes.func,
}

CarouselAnimationView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "CarouselAnimationView",
    container: {
      backgroundColor: "#650101",
      auto: false,
      type: "across",
      height: "570px",
      paddingTopQuery: ["76px", "123px"],
    },
    list: [
      {
        position_image: "left",
        name: "QueueAnim",
        bg: {
          backgroundColor: "#650101",
          imageUrl: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0,
            },
            mobile: {
              width: 0,
              height: 0,
            },
          },
          isBgImage: false,
        },
        position: {
          boxImage: "486px",
          marginLeftImage: "50px",
          marginLeftText: "-100px",
        },
        title: {
          italic: true,
          weight: "normal",
          lineHeight: "100%",
          letterSpacing: "0px",
          color: "#ed747f",
          size: "48pt",
          sizeMedium: "30pt",
          sizeSmall: "20pt",
          align: "center",
          family: "Rage Italic",
          textTransform: "normal",
          type: "right",
          mode: "smooth",
          delay: 200,
          duration: 1600,
          isAnimation: true,
          isEase: false,
          ease: "",
          value: "Forbidden City",
        },
        subtitle: {
          italic: false,
          weight: "normal",
          lineHeight: "100%",
          letterSpacing: "0px",
          color: "#FFFFFF",
          size: "48pt",
          sizeMedium: "30pt",
          sizeSmall: "20pt",
          align: "center",
          family: "Montserrat",
          textTransform: "uppercase",
          type: "alpha",
          mode: "sync",
          delay: 100,
          duration: 800,
          isAnimation: true,
          isEase: true,
          ease: "easeOutQuart",
          value: "RED BEEN PASTE",
        },
        imageUrl: {
          url:
            "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-4TX.png",
          urlMobile: "",
          desktop: {
            width: 0,
            height: 0,
          },
          mobile: {
            width: 0,
            height: 0,
          },
        },
        url_image:
          "https://s3-ap-southeast-1.amazonaws.com/ola2-staging/assets/1/content/ImageView-image-desktop-4TX.png",
        url_image_mobile: "",
        url_bg: "",
        url_bg_mobile: "",
        image: {
          isAnimation: true,
          animation: {
            type: "from",
            ease: "easeInQuart",
            opacity: 0,
            delay: 40,
            duration: 1500,
          },
        },
      },
    ],
    href: {
      url: "",
      target: "",
      isCollection: false,
      collection: 0,
      type: "",
    },
    isLink: false,
  },
  layout: Layout12,
}
export default CarouselAnimationView



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/CarouselAnimationView.js